/**
 * @generated SignedSource<<55f2b9e513911e1ed6d628171dc4a2d9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ModulesCompanyContainerQuery$variables = {
  companyId: string;
};
export type ModulesCompanyContainerQuery$data = {
  readonly companyById: {
    readonly " $fragmentSpreads": FragmentRefs<"ModulesIntegrations_company" | "PlaidTrigger_company" | "PlaidHistoryTable_company" | "QboBulkDeactivateTrigger_company" | "StripeTrigger_company" | "StripeHistoryTable_company">;
  } | null;
};
export type ModulesCompanyContainerQuery = {
  variables: ModulesCompanyContainerQuery$variables;
  response: ModulesCompanyContainerQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "companyId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "companyId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v5 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "CREATED_AT_DESC"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = [
  "orderBy"
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ModulesCompanyContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "companyById",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ModulesIntegrations_company"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PlaidTrigger_company"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PlaidHistoryTable_company"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "QboBulkDeactivateTrigger_company"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "StripeTrigger_company"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "StripeHistoryTable_company"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ModulesCompanyContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "companyById",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationsConnection",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Integration",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "config",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": (v5/*: any*/),
                    "concreteType": "IntegrationScriptResultsConnection",
                    "kind": "LinkedField",
                    "name": "integrationScriptResults",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "IntegrationScriptResultsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "IntegrationScriptResult",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "platform",
                                "storageKey": null
                              },
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "dateThreshold",
                                "storageKey": null
                              },
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "reversed",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "dataTable",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserFile",
                                "kind": "LinkedField",
                                "name": "userFile",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v9/*: any*/)
                    ],
                    "storageKey": "integrationScriptResults(first:10,orderBy:\"CREATED_AT_DESC\")"
                  },
                  {
                    "alias": null,
                    "args": (v5/*: any*/),
                    "filters": (v10/*: any*/),
                    "handle": "connection",
                    "key": "DeactivateHistoryTable_integrationScriptResults",
                    "kind": "LinkedHandle",
                    "name": "integrationScriptResults"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "CompanyUserFilesConnection",
            "kind": "LinkedField",
            "name": "companyUserFiles",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CompanyUserFilesEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompanyUserFile",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserFile",
                        "kind": "LinkedField",
                        "name": "userFile",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v4/*: any*/),
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "meta",
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              (v9/*: any*/)
            ],
            "storageKey": "companyUserFiles(first:10,orderBy:\"CREATED_AT_DESC\")"
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "filters": (v10/*: any*/),
            "handle": "connection",
            "key": "PlaidHistoryTable_companyUserFiles",
            "kind": "LinkedHandle",
            "name": "companyUserFiles"
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "filters": (v10/*: any*/),
            "handle": "connection",
            "key": "StripeHistoryTable_companyUserFiles",
            "kind": "LinkedHandle",
            "name": "companyUserFiles"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f9b0173603cb83eb7e85d4886517e1a6",
    "id": null,
    "metadata": {},
    "name": "ModulesCompanyContainerQuery",
    "operationKind": "query",
    "text": "query ModulesCompanyContainerQuery(\n  $companyId: ID!\n) {\n  companyById(id: $companyId) {\n    ...ModulesIntegrations_company\n    ...PlaidTrigger_company\n    ...PlaidHistoryTable_company\n    ...QboBulkDeactivateTrigger_company\n    ...StripeTrigger_company\n    ...StripeHistoryTable_company\n    id\n  }\n}\n\nfragment DeactivateHistoryContextMenu_integrationScriptResult on IntegrationScriptResult {\n  id\n  kind\n  userFile {\n    rowId\n    id\n  }\n}\n\nfragment DeactivateHistoryTableRow_integrationScriptResult on IntegrationScriptResult {\n  createdAt\n  dateThreshold\n  kind\n  reversed\n  dataTable\n}\n\nfragment DeactivateHistoryTable_integration on Integration {\n  integrationScriptResults(first: 10, orderBy: CREATED_AT_DESC) {\n    edges {\n      node {\n        id\n        platform\n        ...DeactivateHistoryTableRow_integrationScriptResult\n        ...DeactivateHistoryContextMenu_integrationScriptResult\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment ModulesIntegrations_company on Company {\n  id\n  ...PlaidTrigger_company\n}\n\nfragment PlaidHistoryContextMenu_userFile on UserFile {\n  rowId\n}\n\nfragment PlaidHistoryTableRow_userFile on UserFile {\n  createdAt\n  meta\n}\n\nfragment PlaidHistoryTable_company on Company {\n  companyUserFiles(first: 10, orderBy: CREATED_AT_DESC) {\n    edges {\n      node {\n        userFile {\n          id\n          kind\n          ...PlaidHistoryTableRow_userFile\n          ...PlaidHistoryContextMenu_userFile\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment PlaidTrigger_company on Company {\n  integrations {\n    nodes {\n      rowId\n      kind\n      config\n      id\n    }\n  }\n}\n\nfragment QboBulkDeactivateTrigger_company on Company {\n  integrations {\n    nodes {\n      id\n      kind\n      ...DeactivateHistoryTable_integration\n    }\n  }\n}\n\nfragment StripeHistoryContextMenu_userFile on UserFile {\n  rowId\n}\n\nfragment StripeHistoryTableRow_userFile on UserFile {\n  createdAt\n  meta\n}\n\nfragment StripeHistoryTable_company on Company {\n  companyUserFiles(first: 10, orderBy: CREATED_AT_DESC) {\n    edges {\n      node {\n        userFile {\n          id\n          kind\n          ...StripeHistoryTableRow_userFile\n          ...StripeHistoryContextMenu_userFile\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment StripeTrigger_company on Company {\n  integrations {\n    nodes {\n      kind\n      rowId\n      id\n    }\n  }\n  companyUserFiles(first: 10, orderBy: CREATED_AT_DESC) {\n    edges {\n      node {\n        userFile {\n          kind\n          rowId\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "07f1aeaece63e21e27a6c9c9cea2eef0";

export default node;
